
import Vue from "vue";
import dayjs from "dayjs";
import { NewToiletsApiFunc, NewGatewaysApiFunc, setAccessToken } from "@/api";
import { uploadImage } from "@/api/area";
import { Toilet, Gateway } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import ToiletEditor from "./components/ToiletEditor.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import { deleteImage } from "@/api/area";

export type DataType = {
  toilet?: Toilet;
  gateways: Array<Gateway>;
};

export default Vue.extend({
  name: "ToiletDetailScreen",

  components: {
    TheTemplate,
    ToiletEditor,
    BaseCloseButton,
  },

  data(): DataType {
    return {
      toilet: undefined,
      gateways: [],
    };
  },

  mounted(): void {
    this.getToilet();
    this.fetchGateways();
  },

  methods: {
    async fetchGateways(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      // TODO: トイレとまだ紐付いていないものだけにする必要がある？
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewGatewaysApiFunc().listGateways(companyId, undefined, undefined, false);

      if (err != null) {
        this.$handleApiError(err, this.fetchGateways);
        return;
      }

      this.gateways = data.list;
    },

    async getToilet(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const toiletId = this.$router.currentRoute.params.toiletId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewToiletsApiFunc().getToilet(companyId, toiletId);

      if (err != null) {
        this.$handleApiError(err, this.getToilet);
        return;
      }

      this.toilet = data;
    },

    async updateToilet(...toiletAndImage: [Toilet, Blob]): Promise<void> {
      const [toilet, image]: [Toilet, Blob] = toiletAndImage;

      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      const toiletId = this.$router.currentRoute.params.toiletId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewToiletsApiFunc().updateToilet(companyId, toiletId, toilet);

      if (image !== undefined) {
        const fileName: string = dayjs().format("YYYY-MM-DD HH:mm");
        await uploadImage(companyId, toiletId, { file: image, name: fileName });
      }

      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-toilets",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    async deleteImage(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }

      const toiletId = this.$router.currentRoute.params.toiletId;
      await deleteImage(companyId, toiletId);
      return;
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
